<template>
  <div class="homepage-feature-item__wrapper">
    <a-icon
      :original="true"
      :no-hover="true"
      fill="none"
      :icon="item.icon"
      :width="80"
      :height="80"
      class="homepage-feature-item__icon"
    />

    <h3 class="homepage-feature-item__title subtitle-1">
      {{ item.title }}
    </h3>

    <p class="homepage-feature-item__description">
      {{ item.description }}
    </p>
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import AIcon from 'shared/AIcon/index.vue'

export default {
  name: 'HomepageFeatureItem',
  components: { AIcon },
  props: {
    item: propValidator([PROP_TYPES.OBJECT])
  }
}
</script>

<style lang="scss" scoped>
.homepage-feature-item__wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .homepage-feature-item__icon {
    $margin-bottom: (
      $above-desktop-xl: 24px,
      $mobile: 12px
    );

    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
  }

  .homepage-feature-item__title {
    color: $c--coal-black;
    margin-bottom: 8px;
    font-weight: 600;
  }

  .homepage-feature-item__description {
    color: $c--gray-description;

    $font-size: (
      $above-desktop-xl: 20px,
      $mobile: 14px
    );

    $line-height: (
      $above-desktop-xl: 30px,
      $mobile: 20px
    );

    @include setStyleByBreakpoint('font-size', $font-size);
    @include setStyleByBreakpoint('line-height', $line-height);
  }
}
</style>
